// extracted by mini-css-extract-plugin
export default {"table_wrapper":"LaporanSlipGaji_table_wrapper__e2CN2"};